import React, { useEffect, useState } from "react";
import "../styles/Shops.css";
import { useAuth } from "../context/AuthContext";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  addDoc,
} from "firebase/firestore";
import { db } from "../firebase";

import { serverTimestamp } from "firebase/firestore";

import imageCompression from "browser-image-compression";

const LOCATIONS = [
  "Kumarapalayam",
  "Pallipalayam",
  "Sankagiri",
  "Tiruchengode",
];

const CATEGORIES = [
  "Retail & Shopping",
  "Food & Beverage",
  "Health & Wellness",
  "Services & Repairs",
  "Education & Training",
  "Construction & Property",
  "Professional & Financial",
  "Transport & Travel",
  "Manufacturing & Wholesale",
  "Other / Miscellaneous",
];

export default function UserShops() {
  const { user } = useAuth();

  const [shop, setShop] = useState({});
  const [shopDocId, setShopDocId] = useState("");
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (!user) return;

    loadShop();
  }, [user]);

  async function loadShop() {
    try {
      const q = query(
        collection(db, "shops"),
        where("uid", "==", user.uid)
      );

      const snap = await getDocs(q);

      if (!snap.empty) {
        const d = snap.docs[0];

        setShopDocId(d.id);

        setShop({
          id: d.id,
          ...d.data(),
        });
      }

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }

  const handleChange = (key, value) => {
    setShop((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  async function uploadToImgBB(file) {
    const key = process.env.REACT_APP_IMGBB_KEY;

    const fd = new FormData();
    fd.append("image", file);

    const res = await fetch(
      `https://api.imgbb.com/1/upload?key=${key}`,
      {
        method: "POST",
        body: fd,
      }
    );

    const data = await res.json();

    return data.data.url;
  }

  async function uploadShopImage(file) {
  if (!file) return;

  setUploading(true);

  try {
    // Compress image
    const compressedFile = await imageCompression(file, {
      maxSizeMB: 0.3,            // about 300 KB
      maxWidthOrHeight: 1200,    // resize large photos
      useWebWorker: true,
    });

    // Upload compressed image
    const imageUrl = await uploadToImgBB(compressedFile);

    handleChange("Shop Image", imageUrl);

  } catch (err) {
    console.error(err);
    alert("Image upload failed");
  }

  setUploading(false);
}

  async function saveShop() {
  try {
    const shopData = {
      uid: user.uid,
      "Shop Name": shop["Shop Name"] || "",
      "Mobile Number": shop["Mobile Number"] || "",
      Location: shop.Location || "",
      Category: shop.Category || "",
      "Shop Image": shop["Shop Image"] || "",
      Description: shop.Description || "",
      Address: shop.Address || "",
      "Opening Time": shop["Opening Time"] || "",
      "Closing Time": shop["Closing Time"] || "",
      Instagram: shop.Instagram || "",
      Facebook: shop.Facebook || "",
      X: shop.X || "",
      Threads: shop.Threads || "",
      Youtube: shop.Youtube || "",
    };

    if (shopDocId) {
      await updateDoc(doc(db, "shops", shopDocId), {
        ...shopData,
        updatedAt: serverTimestamp(),
      });

      setShop((prev) => ({
  ...prev,
  ...shopData,
}));

      alert("✅ Shop updated successfully");
    } else {
      const newDoc = await addDoc(collection(db, "shops"), {
  ...shopData,
  Likes: 0,
  Shares: 0,
  Type: "Normal",
  createdAt: serverTimestamp(),
  updatedAt: serverTimestamp(),
});

      setShopDocId(newDoc.id);

      setShop((prev) => ({
        ...prev,
        id: newDoc.id,
      }));

      alert("✅ Shop created successfully");
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
}

  if (loading)
    return (
      <p style={{ textAlign: "center" }}>
        Loading...
      </p>
    );

  return (
    <div className="shops-wrap">
      <div className="shops-container">

        <div className="premium-banner">
          🎉 Add your shop and try for free! (demo)
        </div>

        <h2>My Shop</h2>

        <div className="shop-image-upload">

          {shop["Shop Image"] ? (
            <img
              src={shop["Shop Image"]}
              alt=""
              className="shop-preview"
            />
          ) : (
            <div className="shop-placeholder">
              🏪
            </div>
          )}

          <label className="upload-btn">

            Upload Shop Image

            <input
  hidden
  type="file"
  accept="image/*"
  capture="environment"
  onChange={(e) => uploadShopImage(e.target.files[0])}
/>

          </label>

          {uploading && (
  <p style={{ color: "#2563eb", fontWeight: 600 }}>
    ⏳ Compressing & Uploading...
  </p>
)}

        </div>

        <input
          className="shop-search"
          placeholder="Shop Name"
          value={shop["Shop Name"] || ""}
          onChange={(e) =>
            handleChange("Shop Name", e.target.value)
          }
        />

        <input
          className="shop-search"
          placeholder="Mobile Number"
          value={shop["Mobile Number"] || ""}
          onChange={(e) =>
            handleChange("Mobile Number", e.target.value)
          }
        />

        <select
          className="shop-select"
          value={shop.Location || ""}
          onChange={(e) =>
            handleChange("Location", e.target.value)
          }
        >
          <option value="">
            Select Location
          </option>

          {LOCATIONS.map((l) => (
            <option key={l} value={l}>
              {l}
            </option>
          ))}
        </select>

        <select
          className="shop-select"
          value={shop.Category || ""}
          onChange={(e) =>
            handleChange("Category", e.target.value)
          }
        >
          <option value="">
            Select Category
          </option>

          {CATEGORIES.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>

        <textarea
          rows={4}
          className="shop-search"
          placeholder="About your shop"
          value={shop.Description || ""}
          onChange={(e) =>
            handleChange("Description", e.target.value)
          }
        />

        <textarea
          rows={3}
          className="shop-search"
          placeholder="Address"
          value={shop.Address || ""}
          onChange={(e) =>
            handleChange("Address", e.target.value)
          }
        />

        <div
          style={{
            display: "flex",
            gap: 10,
          }}
        >
          <input
            type="time"
            className="shop-search"
            value={shop["Opening Time"] || ""}
            onChange={(e) =>
              handleChange("Opening Time", e.target.value)
            }
          />

          <input
            type="time"
            className="shop-search"
            value={shop["Closing Time"] || ""}
            onChange={(e) =>
              handleChange("Closing Time", e.target.value)
            }
          />
        </div>

        <input
          className="shop-search"
          placeholder="Instagram URL"
          value={shop.Instagram || ""}
          onChange={(e) =>
            handleChange("Instagram", e.target.value)
          }
        />

        <input
          className="shop-search"
          placeholder="Facebook URL"
          value={shop.Facebook || ""}
          onChange={(e) =>
            handleChange("Facebook", e.target.value)
          }
        />

        <input
          className="shop-search"
          placeholder="X URL"
          value={shop.X || ""}
          onChange={(e) =>
            handleChange("X", e.target.value)
          }
        />

        <input
          className="shop-search"
          placeholder="Threads URL"
          value={shop.Threads || ""}
          onChange={(e) =>
            handleChange("Threads", e.target.value)
          }
        />

        <input
          className="shop-search"
          placeholder="YouTube URL"
          value={shop.Youtube || ""}
          onChange={(e) =>
            handleChange("Youtube", e.target.value)
          }
        />

        <button
          className="pf-logout"
          onClick={saveShop}
        >
          Save Shop
        </button>

      </div>
    </div>
  );
}